import DeliveryCommon from '../../components/deliveryCommon/DeliveryCommon';

const ReturnParcelAssign = () => {
	return <DeliveryCommon title='Return From Customer' deliveryType='return' />;
};

export default ReturnParcelAssign;
